import {
  FILL_CUSTOMER_PROFILE_DETAILS,
  HANDLE_DATE_OF_BIRTH_CUSTOMER,
  SET_CUSTOMER_PROFILE_IMAGE_FILE,
  CHANGE_CUSTOMER_PROFILE_SET,
  REMOVE_CUSTOMER_IMAGE_FILE_PROFILE
} from "../constants/ActionTypes";
import { formatPhone } from "../util/normalizePhone";

const INIT_STATE = {
  alertMessage: "",
  showMessage: false,
  errorMessage: false,
  imageFile: null,
  imageid:"",
  editProfile:false,
  customerProfile: {
    firstname: "",
    lastname: "",
    email: "",
    phonenumber: "",
    address1: "",
    address2: "",
    city: "",
    stateId: "",
    country: "",
    zipcode: "",
    gender: "",
    dob: "",
    newPassword: "",
    confirmPassword: "",
    _id: "",
  },
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case CHANGE_CUSTOMER_PROFILE_SET :
        
      return{
        ...state,
        editProfile:true
      }
    case FILL_CUSTOMER_PROFILE_DETAILS:
      const data = JSON.parse(localStorage.getItem("user-data"));
      const isEdit=INIT_STATE.editProfile;
      console.log("ISEDIT",isEdit);
      
      return {
        ...state,
        alertMessage:isEdit ?"Customer Updated SuccessFully":"",
        showMessage: isEdit?true:false,
        customerProfile: {
          ...state.customerProfile,
          firstname: data.firstname,
          lastname: data.lastname,
          email: data.email,
          phonenumber: formatPhone(data.phonenumber),
          address1: data.customer_details.address1,
          address2: data.customer_details.address2,
          city: data.customer_details.city,
          stateId: data.customer_details.state,
          country: data.customer_details.country,
          zipcode: data.customer_details.zipcode,
          gender: data.customer_details.gender,
          dob: data.customer_details.date_of_birth,
          _id: data._id,
        },
        imageFile: data.customer_details.photo ? data.customer_details.photo : "",
        editProfile:false
      };
    case HANDLE_DATE_OF_BIRTH_CUSTOMER:
      const dob = action.payload;
      return { ...state, dob: dob };

      case SET_CUSTOMER_PROFILE_IMAGE_FILE :
        return{...state,imageFile:action.payload}

        case REMOVE_CUSTOMER_IMAGE_FILE_PROFILE:{
          return{...state,imageFile:null,imageid:""}
        }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./reducers/CustomerProfile.js